import { z } from 'zod';

import { schemaTemplate } from './schemaTemplate';

export const schemaTemplateList = z.array(schemaTemplate);

export type SchemaTemplateList = z.infer<typeof schemaTemplateList>;
